import React from 'react';
import { Box, makeStyles } from '@material-ui/core';
import Dialog from '../../../../components/Dialog';
import { i18n } from '../../../../language';

const useStyles = makeStyles((theme) => ({
  delDraftPopContent: {
    fontSize: '1.142rem',
    fontFamily: 'NotoSans-Medium',
    fontWeight: 500,
  },
}));

export default function UpdateThisOneDialog({ showUpdateDialog, closePop, handleUpdate, type }) {
  const classes = useStyles();
  const handleConfirm = () => {
    handleUpdate({ isJustThisOne: false });
    closePop();
  };
  const handleCancel = () => {
    handleUpdate({ isJustThisOne: true });
    closePop();
  };

  return (
    <Dialog
      handleClose={closePop}
      title=""
      cancel={i18n.t('EHANDOVER_JUST_THIS_ONE')}
      confirm={i18n.t('EHANDOVER_UNSENT_SERIES')}
      handleConfirm={handleConfirm}
      handleCancel={handleCancel}
      dialogfootStyle={{ marginTop: '1rem' }}
      open={showUpdateDialog}
      width="100%"
      dialogWidth="50%"
      dialogContentStyle={{ overflowY: 'auto' }}
      isCapitalize={false}
    >
      <Box className={classes.delDraftPopContent}>{i18n.t('EHANDOVER_JUST_THIS_ONE_CONTENT', { type })}</Box>
    </Dialog>
  );
}
